import React from 'react';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import { loadReactControlsComponent } from 'src/components/YandexMap/loaders/componentLoaders';

const YMapZoomControl = loadReactControlsComponent(
  'YMapZoomControl',
  loadModulePromise,
);

const ZoomControlButton = () => <YMapZoomControl />;

export default ZoomControlButton;
